import * as React from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineDot from "@mui/lab/TimelineDot";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import LaptopMacIcon from "@mui/icons-material/LaptopMac";
import HotelIcon from "@mui/icons-material/Hotel";
import RepeatIcon from "@mui/icons-material/Repeat";
import Typography from "@mui/material/Typography";
import T1 from "../../../../resources/images/t1.png";
import T2 from "../../../../resources/images/t2.png";
import T3 from "../../../../resources/images/t3.png";
import T4 from "../../../../resources/images/t4.png";
import T5 from "../../../../resources/images/t5.png";
import T6 from "../../../../resources/images/t6.png";
import T7 from "../../../../resources/images/t7.png";
import T8 from "../../../../resources/images/t8.png";
import T9 from "../../../../resources/images/t8.png";
import T10 from "../../../../resources/images/t10.png";
import T11 from "../../../../resources/images/t11.png";
import T12 from "../../../../resources/images/t12.png";
import T13 from "../../../../resources/images/t13.png";
import T14 from "../../../../resources/images/t14.png";
import T15 from "../../../../resources/images/t15.png";
import FIRST_IMG from "../../../../resources/images/first.png";
import SIMPSON_LOGO from "../../../../resources/icons/logo.png";
import { Box } from "@mui/material";
import SIMPSONS_MILESTONES from "../../../../resources/images/milestones.png";
export default function Page2ForCarousal() {
  const timelineData = [
    {
      year: 2025,
      image: FIRST_IMG,
      desc: "TREM V, BS5 (CEV), CPCB 4+ Products",
    },
    { year: 2024, image: FIRST_IMG, desc: "ISO 45001 3 CYL CNG Version" },
    { year: 2023, image: FIRST_IMG, desc: "SAM & E-Drives" },
    { year: 2022, image: T1, desc: "EU Stage V Products" },
    { year: 2021, image: T2, desc: "TREM IV, BS4, CEV Products" },
    { year: 2020, image: T3, desc: "ISO / IEC 17025:2017 ACCREDITATION" },
    { year: 2019, image: T4, desc: "Development of SJV437 100 KW engine" },
    { year: 2015, image: T4, desc: "175 years of Simpsons" },
    { year: 2014, image: T5, desc: "Development of ST440 100.5 PS Engine" },
    { year: 2013, image: T6, desc: "SJV326 engine launched in North America" },
    { year: 2012, image: T7, desc: "New Emission Lab at Sembium Plant" },
    { year: 2011, image: T8, desc: "Compact SC213 engine launched" },
    {
      year: 2001,
      image: T9,
      desc: "SJ Series engines launched with tech support from AVI, Austria",
    },
    { year: 1998, image: T10, desc: "Power-gen Segment" },
    { year: 1840, image: SIMPSON_LOGO, desc: "Simpsons Establised" },
    { year: "1840 - 1951", image: T15, desc: "Building Coaches, Car Dealers" },
    { year: 1951, image: T14, desc: "Dealers for Perkins Diesel Engines" },
    { year: 1955, image: T13, desc: "Pioneers of Diesel Engines in India" },
    { year: 1990, image: T12, desc: "150 years of Simpsons" },
    {
      year: 1992,
      image: T11,
      desc: "S325 & S433 engine introduced for Tractor, Construction & RTV Vehicles",
    },
  ];
  return (
    <div className="carousal-con">
      <Typography
        variant="h5"
        className="primary-text"
        sx={{ textAlign: "center", mb: 1 }}
      >
        Simpsons - Milestones
      </Typography>
      <img
        src={SIMPSONS_MILESTONES}
        alt="Simpsons Milestones"
        style={{ height: "100%", width: "100%" }}
      />
      {/* <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          position: "relative",
          width: "90%",
          padding: 1,
          margin: "auto",
        }}
      >
        {Array.from(
          { length: Math.ceil(timelineData.length / 7) },
          (_, rowIndex) => {
            const rowItems = timelineData.slice(rowIndex * 7, rowIndex * 7 + 7);
            const isReverse = rowIndex % 2 !== 0;

            return (
              <Box
                key={rowIndex}
                sx={{
                  display: "flex",
                  flexDirection: isReverse ? "row-reverse" : "row",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  position: "relative",
                  borderTop: "3px solid lightGray",
                  borderRight: !isReverse ? "3px solid lightGray" : "",
                  borderLeft: isReverse ? "3px solid lightGray" : "",
                  borderTopLeftRadius: isReverse ? "5px" : "",
                  borderBottomLeftRadius: isReverse ? "5px" : "",
                  borderBottomRightRadius: !isReverse ? "5px" : "",
                  borderTopRightRadius: !isReverse ? "5px" : "",
                  padding: "10px",
                  borderBottom:
                    rowIndex === Math.floor(timelineData.length / 7)
                      ? "3px solid lightGray"
                      : "",
                }}
              >
                {rowItems.map((item, index) => (
                  <Box
                    key={item.year}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "space-between",
                      position: "relative",
                      width: "15%",
                    }}
                  >
                    <Box
                      sx={{
                        width: 70,
                        height: 70,
                        overflow: "hidden",
                        marginBottom: 1,
                      }}
                    >
                      <img
                        src={item.image}
                        alt={`Timeline ${item.year}`}
                        style={{ width: "100%", height: "100%" }}
                      />
                    </Box>
                    <Typography
                      variant="body1"
                      className="primary-text"
                      fontWeight={600}
                    >
                      {item.year}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ textAlign: "center" }}
                      className="primary-text"
                    >
                      {item.desc}
                    </Typography>
                  </Box>
                ))}
              </Box>
            );
          }
        )}
      </Box> */}
    </div>
  );
}
